import React, { useState, useEffect } from "react";
import "./FormRutaIdeal.scss";
import {
   Step,
   StepLabel,
   Stepper,
   Box,
   Grid,
   Container,
   Typography,
} from "@comfama/comfama-ui";
import { graphql, navigate, useStaticQuery} from "gatsby";
import rawToReact from "../../../utils/rawToReact";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import FormBody from "../../molecules/form-body/FormBody";
import { getAllMunicipalities } from "../../../services/municipalities";
import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";
import { saveForm, getToken, saveFormIdealRoute } from "../../../services/formServices";
import { useLocation } from "@reach/router";
import ModalDisableForm from "../../molecules/modal-disabled/modalDisabledForm";

const FormRutaIdeal = (props: any) => {
   const data = useStaticQuery(graphql`
      query contentfulFormEnrutador {
      form: allContentfulContactenos(
            filter: { contentful_id: { eq: "26bwitiP5duoHYda52FoMh" } }
      ) {
            nodes {
               laPginaEstActivaActualmente
               titulosFormulario {
                  descripcion {
                        raw
                  }
                  referenciaFormulario {
                     tipoCampo
                     listaSelect
                     mensajeError
                     inputPrincipal
                     nombreId
                     tituloBotonTerminos
                     textoTerminos {
                        raw
                     }
                     obligatorio
                     seccion
                     tabOrder
                     ayuda
                     placeholder
                  }
                  tituloBoton
               }
            }
         }
      }
   `);

   const contentfulData = data.form.nodes[0];
   const defaultFormValues = {};

   console.log("aa", contentfulData)

   const [formValues, setFormValues] = useState<any>(defaultFormValues);
   const [fieldsToSkip, setFieldsToSkip] = useState<string[]>([]);
   const [inputDisabled, setInputDisabled] = useState<string[]>([]);
   const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
   const [currentIndex, setCurrentIndex] = useState(0);
   const [showModalCancelar, setShowModalCancelar] = useState(false);
   const [showAgeAlert, setShowAgeAlert] = useState(false);
   const [enableTreatment, setEnableTreatment] = useState<boolean>(false);
   const location = useLocation();

   useEffect(() => {
   }, []);

   useEffect(() => {
      municipalitiesList();
   }, [showAgeAlert]);

   useEffect(() => {
      if (currentIndex === 1) {
         document.querySelector('.m-form-group__title ').style.display = 'none';
      }
   }, [currentIndex])


   const inputRegexValidation = (field: any, value: any) => {
      // Evita que el usuario incluya caracteres no alfabeticos
      if (field === "nameContact" || field === "role") {
         const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
         return re.test(value);

      } else if (field === "phone" || field === "aux_number") {
         return value.length <= 10 ? true : false;
      }
      return true;
   };

   const updateInputValue = (field: string, value: any, type?: string) => {

      if (field === "birth_date") {
         const today = new Date();
         const [day, month, year] = value.split('-').map((part: string) => parseInt(part, 10)); 
         const birthDate = new Date(year, month - 1, day);
         const age = today.getFullYear() - birthDate.getFullYear();
         const monthDiff = today.getMonth() - birthDate.getMonth();
         const dayDiff = today.getDate() - birthDate.getDate();

         // Calcula si la persona es menor o igual a 16 años
         if (age < 16 || (age === 16 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))) {
            setFormValues((prev: any) => ({ ...prev, [field]: "" }));
            setShowAgeAlert(true);
            setDisabledButton(true)
            return;
         }
      }
      setFormValues({ ...formValues });


      if (inputRegexValidation(field, value)) {
         setFormValues((prev: any) => {
            return { ...prev, [field]: value };
         });
      }
      setEnableTreatment(field === "terminosCondiciones" && value === 'No' ? true : false);
      setDisabledButton(field === "terminosCondiciones" && value === 'No' ? true : false);
   }

   const handleClickNext = async () => {
   }

   const municipalitiesList = async () => {
      try {
         const data = await getAllMunicipalities();
         const municipalities = [];
         Object.entries(data.data.data).forEach(([key, value]) => {
            municipalities.push(value.name + " - " + value.departmentDTO.name);
         });

         municipalities.sort();
         // Agrega los municipalities como options al campo de tipo select correspondiente
         Object.entries(
            contentfulData.titulosFormulario[2].referenciaFormulario
         ).forEach(([key, value]) => {
            if (value.nombreId === "city") {
               contentfulData.titulosFormulario[2].referenciaFormulario[
                  key
               ].listaSelect = municipalities;
            }
         });
         //
      } catch (error) {
         console.log("API Error:", error);
      }
   };

   const routering = () => {
      if (formValues.employment === "Estoy buscando empleo." && formValues.interestedEmployment === "No") {
         sessionStorage.setItem("router", "Ruta de fortalecimiento hacia la empleabilidad");
      } else if (formValues.interestedEmployment === "Si") {
         sessionStorage.setItem("router", "Ruta express de reclamación del Subsidio");
      } else if (formValues.fomartion === "Si" && formValues.interestedEmployment === "No" && formValues.employment === "No tengo las condiciones o el interés en emplearme en este momento.") {
         sessionStorage.setItem("router", "Ruta de aprendizaje y crecimiento laboral");
      } else if (formValues.employment === "Quiero trabajar por cuenta propia." && formValues.interestedEmployment === "No") {
         sessionStorage.setItem("router", "Ruta de autoempleo");
      } else {
         sessionStorage.setItem("router", "Explora nuestros servicios");
      }
   }

   const handleSubmitForm = async () => {
      const token = await getToken();
      const formattedDate = new Date().toLocaleDateString('es-ES');

      const transformValues = (values) => {
         const requiredOrder = ['Personas con discapacidad', 'Migrantes'];
         
         return {
            ...values,
            poblation: Array.isArray(values.poblation)
               ? values.poblation
                     .sort((a, b) => {
                        const indexA = requiredOrder.indexOf(a);
                        const indexB = requiredOrder.indexOf(b);
                        return (indexA !== -1 ? indexA : Number.MAX_VALUE) - (indexB !== -1 ? indexB : Number.MAX_VALUE);
                     })
                     .join(', ')
               : values.poblation,
         };
      };
      
      const transformedValues = transformValues(formValues);

      const mappedData = {
         idForm: 19,
         answers: [
            ...Object.entries(transformedValues).map(([key, value]) => ({
               contentfulId: key,
               answer: value,
            })),
            {
               contentfulId: 'registerDate',
               answer: formattedDate,
            },
         ],
      };

     sendFormData(mappedData, token)
   };

   const sendFormData = async (mappedData, token) => {
      setDisabledButton(true); 
      try {
        const responseRutaIdeal = await saveFormIdealRoute(mappedData, token);
  
        if (responseRutaIdeal.status === 200) {
         localStorage.setItem('routeName', responseRutaIdeal.data.data.fullName);
         localStorage.setItem('pathUrl', responseRutaIdeal.data.data.pathUrl[0]);
         const pathUrl = responseRutaIdeal.data.data.pathUrl[0].replace(/^\//, '');
         navigate(`./${pathUrl}`);
         routering();
        } else {
          console.error("Error:", responseRutaIdeal.status);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      } finally {
        setDisabledButton(false); 
      }
   }


   const stepperPerc = () => {
       switch (currentIndex) {
           case 0:
               return 0;
           case 1:
               return 15;
           case 2:
               return 87;
           case 3:
               return 100;
           default:
               return 0;
       }
   };

   const fillerStyles = {
      width: `${stepperPerc()}%`,
   };

   const closeCancelForm = () => {
      setShowModalCancelar(false);
   };

   const closeForm = () => {
      navigate(`https://www.comfama.com/servicio-de-empleo/personas/`);
   };

   return (
      !contentfulData.laPginaEstActivaActualmente ? (
         <ModalDisableForm showModal={!contentfulData.laPginaEstActivaActualmente} />
      ) : (
         <Container maxWidth="lg">
            <div className="o-form-ruta-ideal">
               {currentIndex !== 0 && (
                  <div>
                     <div className="progress-bar-aceleradora">
                        <br className="line-break-aceleradora" />
                        <p className="progress-bar-aceleradora-percentage" data-percentage={`${stepperPerc()}%`}>
                           {`${stepperPerc()}% completado`}
                        </p>
                        <div className="progress-bar-aceleradora-container">
                           <div style={fillerStyles} className="progress-bar-aceleradora-filler">
                              <span className="progress-bar-aceleradora-label"></span>
                           </div>
                        </div>
                     </div>
                  </div>
               )}
               {currentIndex === 0 && (
                  <div className="o-form-ruta-ideal__header">
                     <div className="o-form-ruta-ideal__header__title">
                        <h1 className="o-form-ruta-ideal__header__title__font">¡Tu ruta ideal!</h1>
                     </div>
                     <div className="o-form-ruta-ideal__header__subtitle">
                        <p>Conoce todas las posibilidades que tenemos para ti.</p>
                     </div>
                  </div>
               )}
               <div className="o-form-ruta-ideal__form">
                  <div className="o-form-ruta-ideal__form__icontainer">
                     {currentIndex === 0 ? (
                        <img
                           src="https://images.ctfassets.net/203frbsx1z3n/1obyv4Y0t6tpNFkLVEnl6c/40dfb01d44d2163f63f07994eb29b8ad/animacion_uv1.gif"
                           alt="gif_enrutador_1"
                           className="o-form-ruta-ideal__form__icontainer__image"
                        />
                     ) : (
                        <img
                           src="https://images.ctfassets.net/203frbsx1z3n/4eydIwyNc60gKWwNnHNJY3/421dce76bc04a6e83be441eff50dd80b/enrutador_2.png"
                           alt="gif_enrutador_2"
                           className="o-form-ruta-ideal__form__icontainer__image2"
                        />
                     )}
                  </div>
                  <div className="o-form-ruta-ideal__form__fcontainer">
                     {currentIndex === 0 && (
                        <div>
                           <h1 className="o-form-ruta-ideal__form__fcontainer__title">
                              {rawToReact(data.form.nodes[0].titulosFormulario[0].descripcion.raw)}
                           </h1>
                        </div>
                     )}
                     {currentIndex === 2 && (
                        <div>
                           <h1>{rawToReact(data.form.nodes[0].titulosFormulario[2].descripcion.raw)}</h1>
                        </div>
                     )}
                     <div>
                        {currentIndex === 2 && showAgeAlert && (
                           <div className="o-form-ruta-ideal__form__fcontainer__advertiser">
                              <img src="https://images.ctfassets.net/203frbsx1z3n/5shcJF6JSCqJ58gbi16wQd/2ac6bde7964d251b3ef7866a9eeee0e0/icon_21.svg" />
                              <p>Recuerda que para acceder a nuestros servicios debes tener más de 16 años.</p>
                           </div>
                        )}
                        <FormBody
                           titulosFormulario={contentfulData.titulosFormulario}
                           genericClassNameForm={contentfulData.metaTitulo}
                           formValues={formValues}
                           handleSubmitForm={handleSubmitForm}
                           setInputValue={updateInputValue}
                           fieldsToSkip={fieldsToSkip}
                           inputDisabled={inputDisabled}
                           isDisabledButton={isDisabledButton}
                           handleEvent={handleClickNext}
                           setCurrentIndex={setCurrentIndex}
                        >
                           {enableTreatment && (
                              <p className="o-form-ruta-ideal__text_error">
                                 Debes aceptar el tratamiento de datos para poder continuar.
                              </p>
                           )}
   
                           {currentIndex !== 0 && (
                              <button className="boton-cancelar" onClick={() => setShowModalCancelar(true)}>
                                 Cancelar
                              </button>
                           )}
                           {showModalCancelar && (
                              <Modal showModal={showModalCancelar} onClose={closeCancelForm}>
                                 <div className="m-modal-container-validation">
                                    <img src="https://images.ctfassets.net/203frbsx1z3n/7wJzgIk2R4vaz7C8CbNCr2/96befde83bf9ed55174a68dbb45155d4/Ig_modal_cancelar_desktop.png" alt="" />
                                    <h3>¡Ups, aún no has terminado!</h3>
                                    <p>Recuerda que al finalizar estas preguntas podrás recibir una ruta ideal para acceder a nuestros servicios de empleo.</p>
                                    <div className="m-modal-container-validation__buttons">
                                       <div className="a-button-magenta-container__modal-cancelar">
                                          <Button
                                             type="button"
                                             classname="a-button-magenta"
                                             text={"QUIERO VOLVER"}
                                             isDisabled={false}
                                             onClickAction={closeCancelForm}
                                          />
                                       </div>
                                       <div className="a-button-magenta-container__modal-continuar">
                                          <Button
                                             type="button"
                                             classname="a-button-magenta__cancelar-modal"
                                             text={"SALIR"}
                                             isDisabled={false}
                                             onClickAction={closeForm}
                                          />
                                       </div>
                                    </div>
                                 </div>
                              </Modal>
                           )}
                        </FormBody>
                     </div>
                  </div>
               </div>
            </div>
         </Container>
      )
   );
}   

export default FormRutaIdeal;